// api
import { fetchApi } from '@/api'
// actions
const restaurantProductsCategoriesAll = (context) => {
  let url = 'inventory/products/indexrestaurant'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('RESTAURANT_PRODUCTS_CATEGORIES_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantProductsCategoriesForm = (context) => {
  
  let url = 'inventory/products/createRestaurantecategories'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('RESTAURANT_PRODUCTS_CATEGORIES_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantProductsCategoriesShow = (context, payload) => {
  let obj = JSON.parse(payload)
  let data = {}
  let url = 'inventory/products/categories/' + obj.id + '/edit'
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('RESTAURANT_PRODUCTS_CATEGORIES_SHOW', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantProductsCategoriesCreate = (context, payload) => {
  let url = 'inventory/products/categories/storeRestaurant'
  return fetchApi(url, payload, 'POST')
    .then((response) => {
      context.commit('RESTAURANT_PRODUCTS_CATEGORIES_CREATE', response)
      window.history.back()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantProductsCategoriesUpdate = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'inventory/products/categories/' + obj.id
  return fetchApi(url, payload, 'PUT')
    .then((response) => {
      context.commit('RESTAURANT_PRODUCTS_CATEGORIES_UPDATE', response)
      window.history.back()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantProductsCategoriesDelete = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'inventory/products/categories/' + obj.id
  return fetchApi(url, payload, 'DELETE')
    .then((response) => {
      context.commit('RESTAURANT_PRODUCTS_CATEGORIES_DELETE', response)
      location.reload()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

export default {
  restaurantProductsCategoriesAll,
  restaurantProductsCategoriesForm,
  restaurantProductsCategoriesShow,
  restaurantProductsCategoriesCreate,
  restaurantProductsCategoriesUpdate,
  restaurantProductsCategoriesDelete
}



// WEBPACK FOOTER //
// ./src/store/modules/restaurant/products/categories/actions.js